import { POST } from '@/api'

export default {
  namespaced: true,
  state: {
    id: null,
    busy: false,
    extra: {
      unauthorized: false,
    },
  },
  mutations: {
    busy(state, busy) {
      state.busy = !!busy
    },
    show(state, id) {
      state.id = id
    },
    hide(state) {
      state.extra.unauthorized = false
      state.id = null
    },
    update(state, extra) {
      state.extra = { ...state.extra, ...extra }
    },
  },
  actions: {
    async cancelReservation(store, { staffId }) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/reservation/status/update', {
        reservationId: state.id,
        status: state.extra.unauthorized ? 0 : 1,
        staffId,
      })

      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
